// src/components/Layout.jsx
import { Outlet } from 'react-router-dom';
import BottomTabs from './BottomTabs';

export default function Layout() {
  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden">
      {/* Contenu principal - les pages sont rendues ici via <Outlet /> */}
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>

      {/* Bottom tabs fixes en bas */}
      <BottomTabs />
    </div>
  );
}